import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconChevronLeftStyle0 = cosmosIconCss;

const CosmosIconChevronLeft$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconChevronLeft extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd647f9dfd18161ab9f6ce24ca2dc5075a9693aec', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5a5686ff21d05bb1fe20ad118f48c44e0d8b1978', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '804cef8c547b1114940f72266a086d6ec442d393', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m6.56 11.09 5.83 5.82a.5.5 0 0 0 .71 0l.35-.35a.51.51 0 0 0 0-.71l-5.12-5.12 5.12-5.11a.51.51 0 0 0 0-.71l-.35-.35a.5.5 0 0 0-.71 0l-5.83 5.82a.51.51 0 0 0 0 .71Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconChevronLeftStyle0; }
}, [1, "cosmos-icon-chevron-left", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chevron-left"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chevron-left":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChevronLeft$1);
            }
            break;
    } });
}

const CosmosIconChevronLeft = CosmosIconChevronLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChevronLeft, defineCustomElement };
